/**
 * @constant Статические данные для BildCheckListTabPanelContent
 */
export const BILD_CHECK_LIST_TAB_PANEL_CONTENT = {
  publicationsListIsEmptyMsg: 'Публикации отсутствуют',
  photoFromOutPhotobankMsg: 'Только с картинками не из фотобанка',
  searchByDateMsg: 'Поиск по дате'
}
